var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReturn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "16px",
    viewBox: "0 0 19 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.000000, 1.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,15 L13,15 C15.7614237,15 18,12.7614237 18,10 L18,10 C18,7.23857625 15.7614237,5 13,5 L3,5",
    id: "Path-3",
    stroke: "#7A818F",
    strokeWidth: 2,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Rectangle-10-Copy",
    stroke: "#7A818F",
    strokeWidth: 2,
    transform: "translate(6.242641, 5.242641) rotate(225.000000) translate(-6.242641, -5.242641) ",
    points: "3.24264069 2.24264069 9.24264069 2.24264069 9.24264069 8.24264069"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturn);
export default __webpack_public_path__ + "static/media/return.db37e8e8b4ce4c6e4dc0bd2c70f583d1.svg";
export { ForwardRef as ReactComponent };